import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

export interface FertilizerImportTypeDialogModel extends AbstractDialogData {
  text?: string;
  result?: 'overwrite' | 'add';
}

@Component({
  selector: 'app-fertilizer-import-type-dialog',
  templateUrl: './fertilizer-import-type-dialog.component.html',
  standalone: false,
})
export class FertilizerImportTypeDialogComponent extends AbstractDialog<FertilizerImportTypeDialogModel> {
  data = inject<FertilizerImportTypeDialogModel>(MAT_DIALOG_DATA);
  protected readonly mdDialogRef =
    inject<MatDialogRef<FertilizerImportTypeDialogComponent, AbstractDialogResultData<never>>>(
      MatDialogRef,
    );

  add(): void {
    this.confirm({ result: 'add' });
  }

  overwrite(): void {
    this.confirm({ result: 'overwrite' });
  }
}
